import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';

import Dialog from '../../services/Dialogs'

import moment from 'moment'


const ModalAgregarAnexoTrabajador = ( params : any ) => {

  const { show, handleClose } = params


  const dialog = new Dialog();


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({

          documento : yup.string().required(mensajes_validacion_generico),
          debe_visualizar_cliente : yup.boolean(),
  });


  const [ envio_server, setSeEnvio ] = useState<boolean>(false)


  const enviarFormulario = async (registro:any,event:any) =>{
        await dialog.open({
          accept: 'Si',
          cancel: 'Espera',
          dialogClass: '',
          message: '¿Estás seguro?',
          target: event.target,
          template: ''
        })
        let dialogo : any = await dialog.waitForUser()
        if(dialogo){
          try{

          setSeEnvio(true)
          let res_ = await RequestService.create( `catalogo_anexos_trabajador/agregar_anexo` , { ...registro })

          if(res_){
            toast.success('El Anexo se Agregó correctamento')
            setTimeout(()=>{
              handleClose()
            },0)
          }
          else{
            toast.error('Problemas...')
          } 
          }
          catch(e:any){
            toast.error(e.response.data)
            // console.log(e.response.data)
          } 
          
        }
       
  }


  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Agregar Anexo</Modal.Title>
        </Modal.Header>
        <Modal.Body>

    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{

            documento : "",
            debe_visualizar_cliente : false
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>


            <Form.Group className="mb-3" controlId="documento">
              <Form.Label>Anexo o Documento</Form.Label>
              <Form.Control
                required
                name="documento"
                value={values.documento}
                onBlur={(e)=>{ setFieldValue('documento', e.target.value.toUpperCase() ) }}
                onChange={(e)=>{ setFieldValue('documento', e.target.value ) }}
                isInvalid={!!errors.documento}
                style={{textTransform:'uppercase'}}
              />
              <Form.Control.Feedback type="invalid"> {<>{errors.documento}</>} </Form.Control.Feedback>
            </Form.Group>


          <Form.Check 
            type={'checkbox'}
            id={`default`}
            checked={values.debe_visualizar_cliente}
            onChange={(e)=>{ setFieldValue('debe_visualizar_cliente', e.target.checked ) }}
            label={`El Cliente debe ver este documento`}
          />




        </Form>
      )}
    </Formik>



        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
        </Modal.Footer>

      </Modal>
    </>
  );
}


export default ModalAgregarAnexoTrabajador;